<template>
  <div>
    <breadcrumbs :two="{ path: '/cars', name: this.parent_section_name }" three="Автомобиль"></breadcrumbs>
    <div class="main">
      <h3>{{ page_title }}</h3>
      <div class="main-content">
        <loading v-if="loading"></loading>
        <div v-if="!loading">
          <el-row :gutter="24">

          </el-row>

          <el-row :gutter="24">
            <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="el-card box-card is-always-shadow mb-4">
                <div class="el-card__header">
                  <div class="clearfix">
                    <span>Детали автомобиля</span>
                  </div>
                </div>
                <div class="el-card__body">
                  <span>Кузов ID: <strong>{{ item.item_id }}</strong><hr></span>
                  <span>Марка: <strong>{{ item.brand }}</strong><hr></span>
                  <span>Модель: <strong>{{ item.model }}</strong><hr></span>
                  <router-link :to="{name: 'CarsUpload', params: { id: id }}">
                    <el-button round size="mini" icon="el-icon-upload" type="warning">Загрузить</el-button>
                  </router-link>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-table :data="items" border stripe style="width: 100%">
            <template>
              <el-table-column label="Название" prop="name"></el-table-column>
              <el-table-column label="Картинка">
                <template slot-scope="scope">
                  <a :href="scope.row.path" target="_blank">{{ scope.row.path }}</a>
                </template>
              </el-table-column>
              <el-table-column label="Дата обновления" prop="updated_at">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.updated_at) }}
                </template>
              </el-table-column>

              <el-table-column align="right" width="180">
                <template slot-scope="scope">
                  <el-button round size="mini" icon="el-icon-delete" type="warning"
                             @click="deleteItemDialog(scope.row.id,scope.$index)"></el-button>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <el-dialog :visible="dialogVisible" :show-close="true" title="Внимание!">
            <div>
              Вы действительно хотите удалить?
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Нет</el-button>
              <el-button type="primary" @click="deleteItem">Да</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import {axios} from "@/api";
import Loading from "@/components/Loading";

export default {
  name: 'Car',
  data() {
    return {
      loading: true,
      controller: 'user/cars/' + this.$route.params.id + '/info',
      controllerDelete: 'user/png/delete',
      page_title: 'Список файлов',
      parent_section_name: 'Автомобили',
      id: this.$route.params.id,
      activeIndex: 'user/cars/' + this.$route.params.id + '/info',
      item: {},
      items: [],
      dialogVisible: false,
    };
  },
  components: {
    Breadcrumbs,
    Loading
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await axios.get(`${process.env.VUE_APP_API_V1}/${this.controller}`)
            .then((response) => {
              console.log(JSON.stringify(response.data));
              this.item = response.data.items.info;
              this.items = response.data.items.elements;
            })
            .catch((error) => {
              console.log(error);
            });
        this.loading = false;
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loading = true;
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для доступа к странице'
          });
        }
      }
    },
    parsePath(url, format = null) {
      let furl = new URL(url)
      let pathArray = furl.pathname.split('/')
      let frmt = (format == null) ? '' : format
      return pathArray[2] + frmt
    },
    formatDate(inputDate) {
      let createdDate = new Date(inputDate * 1000);
      let day = createdDate.getDate();
      if (day < 10) {
        day = '0' + day
      }
      let month = createdDate.getMonth() + 1;
      if (month < 10) {
        month = '0' + month
      }
      let year = createdDate.getFullYear();
      let hours = createdDate.getHours()
      let minutes = createdDate.getMinutes()
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      let seconds = createdDate.getSeconds()
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds
    },
    deleteItemDialog(id, index) {
      this.dialogVisible = true;
      this.selectID = id;
      this.selectIndex = index;
    },
    async deleteItem() {
      this.dialogVisible = false;
      try {
        this.loading = true;
        await axios.get(`${process.env.VUE_APP_API_V1}/${this.controllerDelete}/${this.selectID}`)
        this.items.splice(this.selectIndex, 1);
        this.loading = false;
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loading = true;
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для доступа к странице'
          });
        }
      }
    },
  },
  async mounted() {
    await this.getData()
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-carousel__item .el-image {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
